// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

// TODO: Backend needs to add approvePurchaseOrder mutation to schema
// For now, using updatePurchaseOrderStatus with APPROVED status
const mutation = graphql`
  mutation ApprovePurchaseOrderMutation(
    $input: UpdatePurchaseOrderStatusInput!
  ) {
    updatePurchaseOrderStatus(input: $input) {
      purchaseOrder {
        id
        poNumber
        status
        approvedBy {
          id
          firstName
          lastName
        }
        approvedAt
        updatedAt
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
    });
  },
};
